import Footer from "../../shared/components/Footer";
import Header from "../../shared/components/Header";
import AboutUs from "./AboutUs";
import HomeSection from "./HomeSection";
import ContactUs from "./ContactUs";
import ServicesSection from "./ServicesSection";

const Home = () => {
  return (
    <>
      <Header />

      <HomeSection id="home" />

      <ServicesSection id="services" />

      <AboutUs id="about" />

      <ContactUs id="contact" />

      <Footer />
    </>
  );
};

export default Home;
